// src/app/directives/if-iframe.directive.ts
import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit
} from '@angular/core';
import { ColombiaIframeService } from '../services/colombia-iframe.service';

@Directive({
  selector: '[ifIframe]'
})
export class IfIframeDirective implements OnInit {
  private hasView = false;
  private showWhenInIframe = true; // default

  @Input() set ifIframe(condition: boolean) {
    this.showWhenInIframe = condition;
    this.updateView();
  }

  @Input() set ifIframeElse(templateRef: TemplateRef<any>) {
    this.elseTemplateRef = templateRef;
    this.updateView();
  }

  private elseTemplateRef: TemplateRef<any> | null = null;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly iframeService: ColombiaIframeService
  ) {}

  ngOnInit(): void {
    this.updateView();
  }

  private updateView(): void {
    // Use the service's method for iframe detection
    const isInIframe = this.iframeService.isRunningInIframe();

    // Clear the view first
    this.viewContainer.clear();
    this.hasView = false;

    if (
      (this.showWhenInIframe && isInIframe) ||
      (!this.showWhenInIframe && !isInIframe)
    ) {
      // Show the main template
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (this.elseTemplateRef) {
      // Show the else template if available
      this.viewContainer.createEmbeddedView(this.elseTemplateRef);
      this.hasView = true;
    }
  }
}
